import React, { useState } from 'react'
import { Tooltip } from "reactstrap"
import { listTags } from '../../helpers/filtersTable'
const TagRequestUpdate = (props) => {
    const { item, tag, itemRequest, onChangeFilterTag } = props
    const [tooltipOpen, setTooltip] = useState(false)

    const _setTooltipOpen = () => {
        setTooltip(!tooltipOpen)
    }

    const isAllowAtag = tag => {
        if(listTags.some(i => i.value === tag)) return true

        return false
    }

    return (
        <span className={tag} id={"Tooltip-Tag-" + item._id + '_' + item.pos}>
            {(tag && isAllowAtag(tag)) ? 
                <div className='cursor-pointer' onClick={() => onChangeFilterTag(tag)}>{tag}</div> :
                tag
            }
            {itemRequest && <Tooltip
                isOpen={tooltipOpen}
                target={"Tooltip-Tag-" + item._id + '_' + item.pos}
                toggle={_setTooltipOpen}
            >
                {itemRequest}
            </Tooltip>}
        </span>
    )
}

export default TagRequestUpdate